// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  background-color: var(--planeed-color-white);
}
@media only screen and (min-width: 460px) {
  .container {
    border: none;
    border-radius: 10px;
    background-color: transparent;
  }
}

h2 {
  text-align: center;
  color: var(--ion-color-secondary);
  margin-bottom: 30px;
}

.team-add-box {
  --ion-background-color: transparent;
  padding: 15px 0;
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: 100%;
}

ion-segment-button {
  font-size: 11px;
  --background-checked: var(--ion-color-secondary);
  --color-checked: var(--planeed-color-white);
  --ion-background-color: var(--ion-color-secondary);
  --indicator-color: transparent !important;
  background: var(--planeed-color-white);
}

.segment-button-checked {
  background: var(--ion-color-secondary);
  border-radius: 9px;
}

.content {
  padding: 10px;
}
@media only screen and (min-width: 460px) {
  .content {
    background-color: var(--planeed-color-white);
  }
}

@media only screen and (min-width: 460px) {
  ion-footer {
    filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.05));
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    padding-bottom: 10px;
  }
}

.footer-section {
  display: flex;
  flex-direction: column;
  row-gap: 15px;
  align-items: center;
  padding: 20px 10px 20px 10px;
  background: var(--planeed-color-white);
}

.globle-icon {
  width: 13px;
  position: absolute;
  left: 26%;
  margin-top: 4px;
}

.headerTeamCompany {
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media only screen and (min-width: 460px) {
  .headerTeamCompany {
    background-color: var(--planeed-color-white);
  }
}
.headerTeamCompany h2 {
  padding-top: 18px;
  margin-bottom: 0;
  margin-top: 0;
}
.headerTeamCompany ion-button {
  display: flex;
  align-items: center;
  margin-top: 0;
  --background: none;
  --padding: 0px;
  height: 40px;
}
.headerTeamCompany ion-icon {
  width: 12px;
}
.headerTeamCompany label {
  color: #888;
  font-size: small;
}
.headerTeamCompany div {
  margin-top: -10px;
}

.teamSitesLabel {
  width: 100px !important;
}

.searchbarHeader {
  display: flex;
  align-items: center;
  padding-left: 55px;
  padding-top: 0;
  height: 30px;
  cursor: pointer;
}
@media only screen and (min-width: 460px) {
  .searchbarHeader {
    padding-top: 10px;
  }
}
.searchbarHeader ion-label {
  padding-left: 15px;
  font-size: 13px;
  color: var(--ion-color-tertiary);
}
.searchbarHeader .custom-search-box {
  position: absolute;
  right: 25px;
  width: 20px;
  height: 20px;
}

.searchbar {
  display: flex;
  align-items: center;
  margin-left: 40px;
  margin-right: 40px;
  margin-top: 10px;
  height: 50px;
  border: solid 2px var(--ion-color-secondary-tint);
  border-radius: 15px;
  animation: fadeIn 0.5s ease-in both;
}
.searchbar ion-searchbar {
  padding-top: 10px;
  padding-bottom: 10px;
  --border-radius: 8px;
  --box-shadow: 0px;
}

.custom-search-team-icon {
  position: absolute;
  left: 25px;
  width: 30px;
  height: 30px;
}

ion-searchbar {
  --background: var(--planeed-color-white);
  border-color: var(--ion-color-primary);
  --ion-color: var(--planeed-color-lightgrey);
  padding-top: 0;
  padding-bottom: 0;
}

.textNotFound {
  min-height: 60px;
  color: #888;
  text-align: center;
  max-width: 80vw;
}

.centeredText {
  display: flex;
  justify-content: center;
}

div.teamNoMemberOf {
  display: flex;
  flex-direction: column;
}
div.teamNoMemberOf img {
  align-self: center;
  height: 170px;
  width: 170px;
  padding-bottom: 10px;
}
div.teamNoMemberOf h2 {
  align-self: center;
  margin-top: 0;
  margin-bottom: 0;
}
div.teamNoMemberOf p {
  min-height: 60px;
  color: #888;
  text-align: center;
  font-size: 12px;
  max-width: 180px;
  align-self: center;
}

div.showMoreButton {
  display: flex;
  justify-content: center;
  /*margin-top: -10px;*/
  padding-top: 4px;
  padding-bottom: 30px;
}

.load-more-TC-btn {
  color: var(--ion-color-secondary);
  text-decoration: underline;
  font-size: 14px;
  margin-top: 0;
  padding: 0;
  height: 20px;
}

.badge-box {
  position: absolute;
  margin-top: 0;
  margin-left: 85px;
  font-size: 1px;
  background: var(--ion-color-warning);
  color: var(--planeed-color-white);
  width: 1px;
  height: 1px;
  padding: 3px 3px;
  border-radius: 5px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.arrowDown {
  margin-top: 5px;
  margin-bottom: -5px;
}

.loadingText {
  text-align: center;
}

@media only screen and (min-width: 460px) {
  .searchbar-container {
    margin: 20px 10px;
    background: white;
    border-radius: 10px;
    padding-bottom: 10px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
